var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomaLandingImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 170,
    viewBox: "0 0 202 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.92 35.51L150.799 3.83539C148.188 1.91736 145.103 0.975135 142.025 1.0005C138.946 0.975135 135.861 1.91736 133.25 3.83539L93.4943 33.0384C91.528 34.4828 88.857 34.4828 86.8911 33.0384L68.7495 19.7126C66.1385 17.7946 63.0539 16.8524 59.9753 16.8781C56.8968 16.8524 53.8121 17.7946 51.2011 19.7126L8.07963 51.3876C3.63007 54.656 1 59.8604 1 65.3965V164.21C1 166.855 3.13519 169 5.76936 169H196.231C198.865 169 201 166.855 201 164.21V49.5192C201 43.9828 198.37 38.7785 193.92 35.51",
    stroke: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 51,
    y1: 85,
    x2: 51,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FB1ED",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomaLandingImg);
export default __webpack_public_path__ + "static/media/DomaLandingImg.c83f5cef2aa9e9571773378d6c255def.svg";
export { ForwardRef as ReactComponent };